import * as Sf from '../../utils/services/salesforce';
import * as Query from '../../queries';

export const getAllSquads = () => {
  return new Promise((resolve, reject) => {
    const query = Query.getAllSquads();
    Sf.runQuery(query).then(
      res => {
        const squads = res.records;
        const squadsNames = squads.map(squad => {
          return squad.Name;
        });
        return resolve({ squads, squadsNames });
      },
      err => console.error(err)
    );
  });
};

export const getAllMembers = () => Sf.runGetQueryInBatchesAndCompileData(Query.getSquadsMembers);

export const getAllUsers = () => {
  return new Promise((resolve, reject) => {
    const query = Query.getCTCByName('Perfis Virada');
    Sf.runQuery(query).then(
      res => {
        const offsetToUse = 2000;
        const joinedProfiles = `'${JSON.parse(res.records[0].Structure__c).profiles.join("', '")}'`;
        const secondQuery = Query.getUsersCount(joinedProfiles);
        Sf.runQuery(secondQuery).then(
          response => {
            const numberOfQueries = Math.ceil(response.records[0].expr0 / offsetToUse);
            const promises = [];

            for (let i = 0; i < numberOfQueries; i++) {
              const currentQuery = Query.getAllUsers(joinedProfiles, offsetToUse, offsetToUse * i);
              promises.push(Sf.runQuery(currentQuery));
            }

            Promise.all(promises).then(
              values => {
                let allUsers = [];

                values.map(currentValues => {
                  allUsers.push(...currentValues.records);
                  return currentValues;
                });

                return resolve(allUsers);
              },
              err => console.error(err)
            );
          },
          err => console.error(err)
        );
      },
      err => console.error(err)
    );
  });
};

export const getAllProfiles = () => {
  return new Promise((resolve, reject) => {
    const query = Query.getAllProfiles();
    Sf.runQuery(query).then(
      res => {
        const allProfiles = res.records;
        return resolve(allProfiles);
      },
      err => console.error(err)
    );
  });
};

export const getAllRoles = () => {
  return new Promise((resolve, reject) => {
    const offsetToUse = 2000;
    const numberOfQueries = 2;
    const promises = [];

    for (let i = 0; i < numberOfQueries; i++) {
      const currentQuery = Query.getAllRoles(offsetToUse, offsetToUse * i);
      promises.push(Sf.runQuery(currentQuery));
    }

    Promise.all(promises).then(
      values => {
        let allRoles = [];

        values.map(currentValues => {
          allRoles.push(...currentValues.records);
          return currentValues;
        });

        return resolve(allRoles);
      },
      err => console.error(err)
    );
  });
};

export const getAllChannels = () => {
  return new Promise((resolve, reject) => {
    const query = Query.getAllChannels();
    Sf.runQuery(query).then(
      res => {
        const allChannels = res.records;
        return resolve(allChannels);
      },
      err => console.error(err)
    );
  });
};
